import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import FormSectionWrapper, { FormSectionTitle, FormSectionDescription, FormSectionContent } from './styled/FormSection';
import './Form';

var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormSection.__proto__ || _Object$getPrototypeOf(FormSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      name: _this.props.name
    }, _this.validate = function () {
      return true;
    }, _this.getSection = function () {
      return {
        name: _this.state.name,
        validate: _this.validate
      };
    }, _this.renderContentChildren = function () {
      return React.Children.map(_this.props.children, function (child) {
        return React.cloneElement(child, {
          form: _this.props.form
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /** Inject Form & Section state */


  _createClass(FormSection, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        FormSectionWrapper,
        null,
        React.createElement(
          FormSectionTitle,
          null,
          this.props.title
        ),
        React.createElement(
          FormSectionDescription,
          null,
          this.props.description
        ),
        React.createElement(
          FormSectionContent,
          null,
          this.renderContentChildren()
        )
      );
    }
  }]);

  return FormSection;
}(Component);

FormSection.defaultProps = {
  name: ''
};
export default FormSection;